import React from "react";

/**
 * User Table Skeleton Loader
 * Provides skeleton loading state for the user table during initial data fetch
 * Based on the invoices page skeleton loader design
 */
export const UserTableSkeleton = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={`user-skeleton-${index}`}>
          {/* User Name */}
          <td style={{ minWidth: "300px", paddingRight: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "50%",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: "120px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </td>
          
          {/* Email */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "180px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Job Title */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "120px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Recipient */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Bank Account */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "80px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Status */}
          <td style={{ paddingRight: "20px" }}>
            <div
              style={{
                width: "80px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Actions */}
          <td style={{ paddingRight: "8px", width: "80px" }}>
            <div
              style={{
                width: "60px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
        </tr>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

